const TYPEFORM_URLS = {
  esp: 'https://vqwrks5mtq2.typeform.com/to/lyxYThIj',
  mex: 'https://vqwrks5mtq2.typeform.com/to/pUP8saFd',
  chl: 'https://vqwrks5mtq2.typeform.com/to/QrfhG8ji',
  col: 'https://vqwrks5mtq2.typeform.com/to/Z8pP3atl',
  cri: 'https://vqwrks5mtq2.typeform.com/to/lyxYThIj',
}

export const IDENTIFIER_REGEX = /[^a-zA-Z0-9-_\u00C0-\u00FF]/g

export default {
  requests: {
    data () {
      return {}
    },
    methods: {
      goToBINCard(search_token, token_id, search_tokens, card_id = null, by_id = false) {
        const useCardId = card_id !== null && card_id !== undefined && card_id !== ''

        let identifier
        const params = new URLSearchParams()

        if (useCardId) {
          identifier = card_id
        } else {
          identifier = search_token.replace(IDENTIFIER_REGEX, ' ')
        }

        if(token_id)
          params.append('token_id', token_id)
        if(search_tokens[0])
          params.append('search_token', search_tokens[0])
        if(by_id)
          params.append('by_id', true)

        const encodedIdentifier = encodeURIComponent(identifier)
        const baseUrl = `${gon.url_for.bin_card_path.replace(':id', encodedIdentifier)}`

        window.location.href = `${baseUrl}?${params}`
      },
      expandBINCard(binCardData, tokenId, searchTokens) {
        sessionStorage.setItem('bin_card_prefetch', JSON.stringify(binCardData))
        const params = new URLSearchParams()
        if (tokenId) params.append('token_id', tokenId)
        const searchToken = (searchTokens && searchTokens[0]) || ''
        if (searchToken) params.append('search_token', searchToken)
        params.append('prefetched', 'true')
        const identifier = searchToken.replace(IDENTIFIER_REGEX, ' ')
        window.location.href = `${gon.url_for.bin_card_path.replace(':id', encodeURIComponent(identifier))}?${params}`
      },
      getCurrentView(fullView) {
        return fullView ? 'vista tarjeta expandida' : 'vista tarjeta compacta'
      }
    },
    computed: {
      typeFormFeedbackLink(){
        if (!this.bin_card) {
          return false
        }
        const paisiso = gon.paisiso
        const baseUrl = TYPEFORM_URLS[paisiso] || TYPEFORM_URLS.esp
        const utmParams = new URLSearchParams()
        utmParams.append('bincard_id', this.bin_card.match)
        utmParams.append('paisiso', paisiso)
        return `${baseUrl}#${utmParams}`
      }
    }
  }
}
